import { render } from "./GuestBanner.vue?vue&type=template&id=3ed87c29&scoped=true"
import script from "./GuestBanner.vue?vue&type=script&lang=js"
export * from "./GuestBanner.vue?vue&type=script&lang=js"

import "./GuestBanner.vue?vue&type=style&index=0&id=3ed87c29&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed87c29"]])

export default __exports__